import TableCell from "@mui/material/TableCell";
import { makeStyles } from "@mui/styles";
import { Header } from "@tanstack/react-table";
import React from "react";
import { getPadding, PaddingObject } from "../../../../util/StyleUtils";
import type { ColumnDefinition } from "../QATable";
import QATableHeaderTitle from "./QATableHeaderTitle";

interface Props<T extends Record<string, unknown>> {
    config: ColumnDefinition<T>;
    header: Header<T, unknown>;
    defaultPadding: PaddingObject | undefined;
}

const useStyles = makeStyles(() => ({
    headerCell: {
        overflow: "hidden",
        border: "1px solid #CCC",
        borderWidth: "0 0 1px 0",
        whiteSpace: "nowrap",
        backgroundColor: "#F6F8FA"
    },
    headerWrapper: {
        display: "flex",
        alignItems: "center",
        overflow: "hidden"
    }
}));

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const QATableHeaderCell: React.FC<Props<any>> = props => {
    const classes = useStyles();

    return (
        <TableCell
            className={classes.headerCell}
            style={{
                width: props.config.width,
                padding: getPadding(props.config.padding, props.defaultPadding ?? {
                    top: 12,
                    bottom: 12,
                    left: 16,
                    right: 16
                })
            }}>

            <div className={classes.headerWrapper}>

                <QATableHeaderTitle
                    header={props.header}
                    config={props.config} />

            </div>

        </TableCell>
    );
};

export default QATableHeaderCell;
